import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog18 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">
          India Has More Financial Tools Than Ever: So Why Isn’t Wealth
          Increasing
        </p>
        <p className="date">{blog.publishDate}</p>

        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        {/* Intro */}
        <p className="sub-paragraph-heading">Introduction</p>

        <p className="paragraph-content">
          India’s financial ecosystem has evolved rapidly, offering easier
          access to investments, credit, and financial planning tools. Despite
          this progress, consistent wealth creation remains a challenge for many
          individuals. This blog explores why financial outcomes have not
          improved at the same pace as access.
        </p>

        <p className="sub-paragraph-heading">
          1. Financial Access Has Increased Dramatically
        </p>

        <p className="paragraph-content">Today, individuals can:</p>

        <ul className="paragraph-content">
          <li>Invest in mutual funds and stocks within minutes</li>
          <li>Access credit instantly</li>
          <li>Use multiple apps for budgeting and tracking</li>
        </ul>

        <p className="paragraph-content">
          This has lowered entry barriers across financial activities.
        </p>

        <p className="sub-paragraph-heading">
          2. Activity Has Replaced Direction
        </p>

        <p className="paragraph-content">
          More people are financially active, but not necessarily financially
          structured.
        </p>

        <ul className="paragraph-content">
          <li>Frequent investing without long-term goals</li>
          <li>Switching strategies based on trends</li>
          <li>Short-term focus over long-term planning</li>
        </ul>

        <p className="paragraph-content">
          Activity has replaced direction in modern financial behavior. Without
          clarity, financial efforts do not compound effectively.
        </p>

        <p className="sub-paragraph-heading">
          3. Too Many Options Create Fragmentation
        </p>

        <p className="paragraph-content">
          The abundance of choices has led to inconsistent decision-making.
        </p>

        <ul className="paragraph-content">
          <li>Savings without allocation</li>
          <li>Investments without timelines</li>
          <li>Constant changes in financial strategy</li>
        </ul>

        <p className="paragraph-content">
          More options have created more confusion, not better outcomes. This
          fragmentation reduces long-term financial growth.
        </p>

        <p className="sub-paragraph-heading">
          4. The Execution Gap Is the Real Problem
        </p>

        <p className="paragraph-content">
          Financial knowledge is widely available. However:
          <br />
          <br />
          Knowing what to do is easy. Doing it consistently is rare. Plans fail
          not because they are incorrect, but because they are not followed over
          time.
        </p>

        <p className="sub-paragraph-heading">
          5. Income Growth Is Not Equal to Wealth Growth
        </p>

        <p className="paragraph-content">
          Higher income does not automatically lead to financial stability.
          Common outcomes include:
        </p>

        <ul className="paragraph-content">
          <li>Increased spending</li>
          <li>Lifestyle upgrades</li>
          <li>Higher liabilities</li>
        </ul>

        <p className="paragraph-content">
          Wealth is built by repetition, not by discovery. Without discipline,
          income growth does not translate into wealth.
        </p>

        <p className="sub-paragraph-heading">
          6. Systems Are More Important Than Strategies
        </p>

        <p className="paragraph-content">
          Successful financial planning depends on systems, not complexity.
          Examples:
        </p>

        <ul className="paragraph-content">
          <li>Automated investments</li>
          <li>Defined budgeting rules</li>
          <li>Controlled use of credit</li>
          <li>Regular financial reviews</li>
        </ul>

        <p className="paragraph-content">
          These systems create consistency and long-term growth.
        </p>

        <p className="sub-paragraph-heading">Conclusion</p>

        <p className="paragraph-content">
          India’s financial tools have improved significantly, but outcomes
          depend on behavior. The gap is no longer access or knowledge. It is
          consistency and structure. Individuals who focus on disciplined
          systems rather than constant changes are more likely to achieve
          long-term financial stability.
        </p>

        {/* FAQ */}
        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>

        <FaqAccordion>
          <h4 className="faq-question">
            Q1. Why is wealth not increasing despite higher income?
          </h4>
          <p className="faq-answer">
            Without proper financial planning, higher income often leads to
            increased spending and liabilities rather than savings and
            investments.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q2. What is the biggest mistake in financial planning?
          </h4>
          <p className="faq-answer">
            Lack of consistency and absence of clear financial goals are the
            most common mistakes.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q3. How can someone improve financial discipline?
          </h4>
          <p className="faq-answer">
            Automate investments, create a budget, and review finances
            regularly.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q4. Are financial apps enough for wealth building?
          </h4>
          <p className="faq-answer">
            Apps provide tools, but outcomes depend on how consistently and
            effectively they are used.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q5. What is the key to long-term wealth creation?
          </h4>
          <p className="faq-answer">
            Consistent investing, controlled spending, and disciplined financial
            behavior over time.
          </p>
        </FaqAccordion>

        <br />
        <br />
      </div>
    </div>
  );
};

export default Blog18;
